/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabTestCategory from './lab-test-category';
import LabTestCategoryDetail from './lab-test-category-detail';
import LabTestCategoryUpdate from './lab-test-category-update';
import LabTestCategoryDeleteDialog from './lab-test-category-delete-dialog';

const LabTestCategoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabTestCategory />} />
    <Route path="new" element={<LabTestCategoryUpdate />} />
    <Route path=":id">
      <Route index element={<LabTestCategoryDetail />} />
      <Route path="edit" element={<LabTestCategoryUpdate />} />
      <Route path="delete" element={<LabTestCategoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabTestCategoryRoutes;
